module.exports = __webpack_public_path__ + "static/surgery-12bfb98bfd2ab6a2f1665ea4a8941dca.jpg";